export default "__VITE_ASSET__CWiPDRbM__"